import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { useRouter } from 'next/router'
import { cn } from '@/lib/utils'
import { LANGUAGE_OPTIONS, useDictionary, useLocale } from '@/lib/i18n'

interface LanguageSwitchProps {
    className?: string
    onSelect?: () => void
}

const LanguageSwitch: FC<LanguageSwitchProps> = ({ className, onSelect }): ReactNode => {
    const { pathname } = useRouter()
    const locale = useLocale()
    const t = useDictionary()

    return (
        <div
            role='group'
            aria-label={t.nav.language}
            className={cn('inline-flex items-center rounded-full border border-border bg-white/[0.03] p-0.5', className)}
        >
            {LANGUAGE_OPTIONS.map((option) => {
                const active = option.locale === locale

                return (
                    <Link
                        key={option.locale}
                        href={pathname}
                        locale={option.locale}
                        lang={option.lang}
                        hrefLang={option.locale}
                        aria-current={active ? 'true' : undefined}
                        onClick={onSelect}
                        className={cn(
                            'rounded-full px-3 py-1.5 text-xs font-semibold tracking-wide transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
                            active ? 'bg-foreground text-background' : 'text-muted-foreground hover:text-foreground'
                        )}
                    >
                        {option.label}
                    </Link>
                )
            })}
        </div>
    )
}

export default LanguageSwitch
